var CurrentUser = require("lib/account/CurrentUser");
import fetch from 'cross-fetch';

var AutograderFeedback = {

	preProcess: function(submitAnswerData) {
		var preProcessing= {};
		//ALPHA RATIO - Amount of alpha characters versus 
		var alphaChars = submitAnswerData["answer"].match(/[a-zA-Z]/g);
		if (alphaChars != null) {
			var alphaRatio = alphaChars.length / submitAnswerData["answer"].replace(/\s/g,"").length;;
		} else {
			var alphaRatio = 0;			
		}
	    preProcessing["alpha_ratio"] = alphaRatio;
		
		return preProcessing;
	}, 

	getHost() {
		if ($wr.isStaging()) {
			return "https://alex5.savvashortondev.com";
		} else if ($wr.isProduction()) {
			return "https://alex5.whooosreading.org";
		} else {
			return "https://alex5.savvashortondev.com";
		}
			
	},

	getFitbApiHost() {
		if ($wr.isProduction()) {
			return "https://grading.whooosreading.org";
		} else {
			return "https://grading.savvashortondev.com"
		}		
	},

	getEssayScorerHost() {
		if ($wr.isProduction()) {
			return "https://essay-grading.savvashorton.com/api/v1/grade"
		} else {
			return "https://savvas-essayscoring-staging.savvashortondev.com/api/v1/grade"
		}		
	},

	requestOps(bodyData) {
		return {
			method: "POST",
			mode: "cors", // no-cors, cors, *same-origin
			cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
			headers: {
				"Content-Type": "application/json; charset=utf-8",
			},
			redirect: "follow", // manual, *follow, error
			referrer: "no-referrer", // no-referrer, *client
			body: JSON.stringify(bodyData),
		}
	},

	fetch: function(answerData, callback) {		
		if (answerData.quiz) {
			var quiz = answerData.quiz;
		} else {
			var quiz = false;
		} 
		var currentUserData = CurrentUser.get();

		var gradeLevel = currentUserData.prefs.academic_level;
		var gradeLevel = answerData.gradeLevel ? answerData.gradeLevel : currentUserData.prefs.academic_level;
		var studentID = currentUserData.id;
		var studentFirstName = currentUserData.first_name;

		if (answerData.sentenceStarterText) {
			var fullAnswerText = answerData.sentenceStarterText + " " + answerData.answer;
		} else {
			var fullAnswerText = answerData.answer;
		}

		var submitAnswerData = {
			answer: fullAnswerText.trim(), question_text: answerData.questionText,
			answer_parts: answerData.answerParts, starters: answerData.starters,
			question_key: answerData.questionKey,
			grade: gradeLevel, student_id: studentID,
			quiz: quiz, paste_detected: answerData.pasteDetected, duration: answerData.duration
		}

		if (answerData.forward) {
			submitAnswerData["forward"] = answerData.forward
		}
		
		if (answerData.text) {
			submitAnswerData.text_id = answerData.text.text_id;
		}

		submitAnswerData["pre_processing"] = AutograderFeedback.preProcess(submitAnswerData);

		var autograderPath = answerData.gradeDemo ? this.getHost() + "/api/v5/grade_demo" : this.getHost() + "/api/v5/grade?which=all";
		var request = this.requestOps(submitAnswerData);

		fetch(autograderPath, request).then(res => {
		    if (res.status >= 400) {
		      throw new Error("Bad response from server");
		    }
		    return res.json();
		  }).then(response => {
		// $wr.postJSON(autograderPath, submitAnswerData, function(response) {
			// var autograderData = response.content;
			var autograderData = response.content
			// var newContext = AutograderFeedback.updateContext(autograderContext, response.evaluation);

			var feedback = autograderData.assisting;

			if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {

				if (answerData.text) {
					var feedbackSubs = {
						firstName: CurrentUser.get().first_name,
						textVariety: answerData.text.text_variety,
						bookTitle: answerData.text.title
					}
				} else {
					var feedbackSubs = {
						firstName: CurrentUser.get().first_name,
					}
				}

				var autograderData = _.extend({}, autograderData, {
					feedback_subs: feedbackSubs
				})

				callback({ autograderData });

			} else {
				callback({ noFeedback: true, autograderData });
			}

		}, function() {
			console.error("Failed to get immediate feedback. Falling back to normal submit.");
			callback({ noFeedback: true, autograderData: undefined });

		}.bind(this));
	},

	formatShortAnswerRequest: function(answerData) {
		if (answerData.quiz) {
			var quiz = answerData.quiz;
		} else {
			var quiz = false;
		} 
		var currentUserData = CurrentUser.get();

		var gradeLevel = currentUserData.prefs.academic_level;
		var gradeLevel = answerData.gradeLevel ? answerData.gradeLevel : currentUserData.prefs.academic_level;
		var studentID = currentUserData.id;
		var studentFirstName = currentUserData.first_name;

		if (answerData.sentenceStarterText) {
			var fullAnswerText = answerData.sentenceStarterText + " " + answerData.answer;
		} else {
			var fullAnswerText = answerData.answer;
		}

		var submitAnswerData = {
			answer: fullAnswerText.trim(), question_text: answerData.questionText,
			answer_parts: answerData.answerParts, starters: answerData.starters,
			question_key: answerData.questionKey,
			grade: gradeLevel, student_id: studentID,
			quiz: quiz, paste_detected: answerData.pasteDetected, duration: answerData.duration
		}

		if (answerData.forward) {
			submitAnswerData["forward"] = answerData.forward
		}
		
		if (answerData.text) {
			submitAnswerData.text_id = answerData.text.text_id;
		}

		submitAnswerData["pre_processing"] = AutograderFeedback.preProcess(submitAnswerData);
		
		return submitAnswerData
	},

	formatShortAnswerResults: function (response, answerData, callback) {
		var autograderData = response.content
		var feedback = autograderData.assisting;
		if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {

			if (answerData.text) {
				var feedbackSubs = {
					firstName: CurrentUser.get().first_name,
					textVariety: answerData.text.text_variety,
					bookTitle: answerData.text.title
				}
			} else {
				var feedbackSubs = {
					firstName: CurrentUser.get().first_name,
				}
			}

			var autograderData = _.extend({}, autograderData, {
				feedback_subs: feedbackSubs
			})

			callback({ autograderData });

		} else {
			callback({ noFeedback: true, autograderData });
		}
	},

	fetchFuzzyMatch: function(answerData, callback) {	

		answerData["grade"] = CurrentUser.get().prefs.academic_level;
		var matchPath = this.getFitbApiHost() + "/api/v1.0/fuzzy_match";
		var request = this.requestOps(answerData)

		fetch(matchPath, request).then(res => {
			if (res.status >= 400) {
				throw new Error("Bad response from server");
			}
			return res.json();
		}).then(response => {
			callback({ noFeedback: true, autograderData: response.content });

		}, () => {
			console.error("Failed to get immediate matching. Falling back to normal submit.");
			callback({ noFeedback: true, autograderData: undefined });

		});
	},

	formatQuestionBuilderRequest: function(answerData) {
		var currentUserData = CurrentUser.get();

		var gradeLevel = currentUserData.prefs.academic_level;
		
		var fullAnswerText = answerData.answer;

		var submitAnswerData = {
			answer: fullAnswerText, question_text: "What is your favorite character?",
			grade: gradeLevel
		}

		if (answerData.text) {
			submitAnswerData.text_id = answerData.text.text_id;
		}

		submitAnswerData.question_builder = true

		return submitAnswerData
	},

	formatQuestionBuilderResults: function(response, answerData, callback) {
		var autograderData = response.content
			
		var feedback = autograderData.assisting;

		if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
			var feedbackSubs = {
				firstName: CurrentUser.get().first_name,
				textVariety: answerData.text.text_variety,
				bookTitle: answerData.text.title
			}

			var autograderData = _.extend({}, autograderData, {
				feedback_subs: feedbackSubs
			})

			callback({ autograderData });

		} else {
			callback({ noFeedback: true, autograderData });
		}
	},

	fetchQuestionBuilder: function(answerData, callback) {		
		
		var currentUserData = CurrentUser.get();

		var gradeLevel = currentUserData.prefs.academic_level;
		
		var fullAnswerText = answerData.answer;

		var submitAnswerData = {
			answer: fullAnswerText, question_text: "What is your favorite character?",
			grade: gradeLevel
		}

		if (answerData.text) {
			submitAnswerData.text_id = answerData.text.text_id;
		}

		submitAnswerData.question_builder = true
		var autograderPath = this.getHost() + "/api/v5/grade?which=all";
		var request = this.requestOps(submitAnswerData);

		fetch(autograderPath, request).then(res => {
		    if (res.status >= 400) {
		      throw new Error("Bad response from server");
		    }
		    return res.json();
		}).then(response => {
			
			var autograderData = response.content
			
			var feedback = autograderData.assisting;

			if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
				var feedbackSubs = {
					firstName: CurrentUser.get().first_name,
					textVariety: answerData.text.text_variety,
					bookTitle: answerData.text.title
				}

				var autograderData = _.extend({}, autograderData, {
					feedback_subs: feedbackSubs
				})

				callback({ autograderData });

			} else {
				callback({ noFeedback: true, autograderData });
			}

		}, function() {
			console.error("Failed to get immediate feedback. Falling back to normal submit.");
			callback({ noFeedback: true, autograderData: undefined });

		}.bind(this));
	},

	formatEssayResults: function (response, callback) {		
		var autograderData = response.content
		var feedback = autograderData.feedback;

		if (feedback && feedback.selected_content && _.size(feedback.selected_content) > 0) {
			feedback['selected_feedback'] = feedback.eligible_feedback[0]

			var feedbackSubs = {
				firstName: CurrentUser.get().first_name
			}

			var autograderData = _.extend({}, autograderData, {
				feedback_subs: feedbackSubs
			})

			callback({ autograderData });

		} else {
			callback({ noFeedback: true, autograderData });
		}
	},

}

module.exports = AutograderFeedback;



// WEBPACK FOOTER //
// ./modules/lib/web/AutograderFeedback.js